module.exports = __webpack_public_path__ + "static/assets/2bcc1426567c2ca1179de43c02577d1a.svg";